<template>
    <div class="toolbar">
        <move-tool class="tool"></move-tool>&#160;<turn-tool class="tool"></turn-tool>&#160;<createPoint-tool class="tool"></createPoint-tool>
    </div>
</template>

<style scoped>
.toolbar {
    z-index: 10;
    position: absolute;
    top: 2em;
    left: 2em;
    filter: drop-shadow(0.1em 0.1em 0.2em black);
}

.tool {
    width: 2em;
    height: 2em;
    color: white;
    background: lightgray;
    display: inline-block;
}
</style>


<script>

import toolbar from "./toolbar.js";
import moveTool from "./move/move-tool.vue";
import turnTool from "./turn/turn-tool.vue";
import createPointTool from "./createpoint/createpoint-tool.vue";

const getCurrentTool = toolbar.getCurrentTool;
const setCurrentTool = toolbar.setCurrentTool;
const init = toolbar.init;
const resetOthers = toolbar.resetOthers;

export default {
    name: "toolbar",
    components: {
        moveTool, turnTool, createPointTool
    },
    data: function () {
        return {
            tools: toolbar.tools,
            components: toolbar.toolComponents,
            names: toolbar.toolNames,
        };
    },
    mounted () {
        toolbar.mounted(this);
        console.log("Toolbar mounted.");
    },
    getCurrentTool, setCurrentTool, init,
    resetOthers: resetOthers,
};
</script>
